(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/directives/scSimpleProgress/template', '<div class="{{::bc}}_progress-bar">\n' + '  <div\n' + '    class="{{::bc}}_progress-bar-goal"\n' + '    data-ng-style="::{height: height, \'background-color\': goalColor }"\n' + '  >\n' + '    <div\n' + '      class="{{::bc}}_progress-bar-raised"\n' + '      data-ng-style="{ width: percentage + \'%\', \'background-color\': raisedColor }"\n' + '    ></div>\n' + '  </div>\n' + '</div>\n' + '');
}]);
})();